<template>
    <div :class="getComputedClasses()">
        <a :href="item.link">
            <div class="product-cross-promo-item__container u-flex u-flex--column" v-if="itemType !== 'group'">
                <div class="product-cross-promo-item__container__wrapper">
                    <div v-if="item.secondary" class="image-container u-bg-color-white">
                        <div class="background-image" :style="backgroundStyle(item.secondary)"></div>
                    </div>

                    <div class="image-container u-bg-color-white" :class="{ 'primary': item.secondary.length > 0 }">
                        <div class="background-image" :style="backgroundStyle(item.primary)"></div>
                    </div>
                </div>
                <div
                    class="product-cross-promo-item__container__body u-flex--grow u-padd-all-half u-flex u-flex--column u-flex--justify-btwn">
                    <h3 :class="getProductHeaderClass()"><span class="name" v-html="item.name"></span></h3>
                    <div>
                        <p v-if="item.part" class="part u-font-aeonik u-color-gray u-mrg-none">Part #{{ item.part }}</p>
                        <div v-if="parseInt(item.variations) > 0" class="item-variations">
                            <strong>{{ item.variations }}</strong> Product Variations
                        </div>
                    </div>
                </div>
                <div v-if="item.new" class="product-cross-promo-item__container__new u-font-aeonik-bold">New</div>
            </div>
            <div class="product-cross-promo-item__container u-flex u-flex--column" v-if="itemType === 'group'">

                <div class="product-group">
                    <div class="product-group__name">
                        <h3 class="u-mrg-top-none u-mrg-btm-qtr u-color-black"><span class="name"
                                v-html="item.name"></span></h3>
                        <div v-if="parseInt(item.variations) > 0" class="item-variations u-color-black">
                            <strong>{{ item.variations }}</strong> Product Variations
                        </div>
                    </div>
                    <div class="product-group__image">
                        <div class="background-image" :style="backgroundStyle(item.primary)"></div>
                    </div>
                </div>
                <div class="product-group-body">

                    <span><strong>Explore options</strong></span>

                </div>
                <div v-if="item.new" class="product-cross-promo-item__container__new u-font-aeonik-bold">New</div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object
        },
        use: {
            type: String,
        },

    },
    data() {
        return {
            root: '/assets/toolkit/images/'
        };
    },
    mounted() {
    },
    methods: {
        backgroundStyle(src) {
            return 'background-image:url(' + src + ');';
        },
        getComputedClasses() {
            let result = "product-cross-promo-item fx-item fx-span-6@md fx-span-3@lg";

            if (this.use === "ag") {
                result = "product-cross-promo-item fx-item fx-span-6@md fx-span-3@lg";
            }
            else if (this.use === "newprod") {
                result = "product-cross-promo-item fx-item fx-span-6@md fx-span-3@lg";
            }

            return result;
        },
        getProductHeaderClass() {
            let result = "u-mrg-top-none u-mrg-btm-qtr";

            if (this.use === "newprod") {
                result = "u-mrg-top-none u-mrg-btm-qtr u-txt-smm";
            }

            return result;
        }
    },
    computed: {
        itemType() {
            if (this.item.type) {
                return this.item.type
            } else {
                return ''
            }
        }
    }
};
</script>
